import {Service} from "@angular/core";
import type {Observable} from "rxjs";
import {RequestBuilder} from "../../models/RequestBuilder";
import {SystemInformation} from "../../models/SystemInformation";
import {BaseApi} from "./base-api";

@Service()
export class SystemInformationApi extends BaseApi {
  public constructor() {
    super("system-information");
  }

  public getSystemInformation(suppressErrorMessage: boolean = false): Observable<SystemInformation> {
    return this.execute(RequestBuilder.get().expectJsonObject().skipErrorHandler(suppressErrorMessage))
      .notNull().decodeJsonObjectOf(SystemInformation);
  }
}
